import React from 'react';
import { IconProps } from '../types/types';

const CHFJPY: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 38 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <circle cx={13.346} cy={13.505} fill="#fff" r={13.34} />
        <path d="M13.34 26.845c7.367 0 13.34-5.973 13.34-13.34 0-7.368-5.973-13.34-13.34-13.34S0 6.137 0 13.505c0 7.367 5.973 13.34 13.34 13.34Z" fill="#F0F0F0" />
        <path
            d="M0 13.505c0 5.288 3.078 9.858 7.54 12.016V1.488C3.078 3.646 0 8.216 0 13.505ZM26.645 13.505c0 5.288-3.078 9.858-7.54 12.016V1.488c4.462 2.158 7.54 6.728 7.54 12.017ZM15.661 15.244l2.32-1.16-1.16-.58v-1.16l-2.32 1.16 1.16-2.32h-1.16l-1.16-1.74-1.16 1.74h-1.16l1.16 2.32-2.32-1.16v1.16l-1.16.58 2.32 1.16-.58 1.16h2.32v1.74h1.16v-1.74h2.32l-.58-1.16Z"
            fill="#D80027"
        />
        <circle cx={13.333} cy={13.332} fill="#fff" r={13.331} />
        <path d="M13.331 26.663c7.363 0 13.332-5.969 13.332-13.332C26.663 5.97 20.694 0 13.33 0 5.97 0 0 5.969 0 13.331c0 7.363 5.969 13.332 13.331 13.332Z" fill="red" />
        <path d="M11.004 7.165h3.75v4.375h4.375v3.75h-4.375v4.375h-3.75V15.29H6.629v-3.75h4.375V7.165Z" fill="#fff" />
        <path d="M24.33 40.825c7.362 0 13.33-5.968 13.33-13.33s-5.968-13.33-13.33-13.33S11 20.133 11 27.495s5.968 13.33 13.33 13.33Z" fill="#F0F0F0" />
        <path d="M24.33 33.29a5.796 5.796 0 1 0 0-11.591 5.796 5.796 0 0 0 0 11.591Z" fill="#D80027" />
    </svg>
);

export default CHFJPY;
